<template>
    <div>
        <p>Här visas innehållet på sidan</p>
    </div>
</template>
